import React, { useEffect, useState } from "react";
import aboutBg from "../../images/bg/service-bg.png";
import { Link } from "react-router-dom";
import gif from "../../images/icon/b10c3e43e836d32554bf.gif";
import arrowIcon from "../../images/icon/rotate-arrow-black.svg";
import websiteDesignImg from "../../images/webtechhome/website-design.jpg";
import mobileAppDevelopmentImg from "../../images/webtechhome/mobile-app-development.jpg";
import webDevelopmentImg from "../../images/webtechhome/web-development.jpg";
import eCommerceDevelopmentImg from "../../images/webtechhome/ecommerce-development.jpg";
import uiUxDesignImg from "../../images/webtechhome/uiuxdesigns.jpg";
import digitalMarketingImg from "../../images/webtechhome/digital-marketing.jpg";
interface ServiceItem {
  id: number;
  title: string;
  desc: string;
  img: string;
  link: string;
}

const ThmBtnArrow = () => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="5.06592" y="19.9785" width="20.5712" height="2.61221" transform="rotate(-40.2798 5.06592 19.9785)" fill="white" />
    <rect x="7.97095" y="7.24463" width="2.61221" height="2.61221" transform="rotate(-40.2798 7.97095 7.24463)" fill="white" />
    <rect x="11.6523" y="7.54834" width="2.61221" height="2.61221" transform="rotate(-40.2798 11.6523 7.54834)" fill="white" />
    <rect x="15.334" y="7.85205" width="2.61221" height="2.61221" transform="rotate(-40.2798 15.334 7.85205)" fill="white" />
    <rect x="18.7119" y="11.8374" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.7119 11.8374)" fill="white" />
    <rect x="18.4084" y="15.52" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.4084 15.52)" fill="white" />
    <rect x="18.104" y="19.2012" width="2.61221" height="2.61221" transform="rotate(-40.2798 18.104 19.2012)" fill="white" />
  </svg>
);

const services: ServiceItem[] = [
  {
    id: 1,
    title: "Website Design",
    desc: "Fast-loading, mobile-responsive websites tailored to your business goals, user behaviour, and SEO strategy.",
    img: websiteDesignImg,
    link: "/website-design",
  },
  {
    id: 2,
    title: "Mobile App Development",
    desc: "Native and cross-platform Android, iOS, and web apps — robust, scalable, and user-friendly at competitive prices.",
    img: mobileAppDevelopmentImg,
    link: "/mobile-app-development",
  },
  {
    id: 3,
    title: "Web Development",
    desc: "SEO-friendly, responsive websites built with the latest tools — from landing pages to complex business platforms.",
    img: webDevelopmentImg,
    link: "/web-development",
  },
  {
    id: 4,
    title: "E-Commerce Development",
    desc: "Custom-built online stores with flexible PHP scripts, easy admin panels, and go-live support within days.",
    img: eCommerceDevelopmentImg,
    link: "/e-commerce-development",
  },
  {
    id: 5,
    title: "UI/UX Design",
    desc: "Intuitive, visually appealing interfaces crafted through research, wireframes, and user-centred design.",
    img: uiUxDesignImg,
    link: "/ui-ux-design",
  },
  {
    id: 6,
    title: "Digital Marketing",
    desc: "End-to-end SEO, content, and campaign services to drive traffic, leads, and measurable online growth.",
    img: digitalMarketingImg,
    link: "/digital-marketing",
  },
];
const ServiceSection: React.FC = () => {
  const [activeId, setActiveId] = useState<number>(1);

  useEffect(() => {
    const bgEl = document.querySelector<HTMLElement>(".xb-service-wrap");
    if (bgEl) bgEl.style.backgroundImage = `url(${aboutBg})`;
  }, []);

  return (
    <section className="service pt-135">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="sec-title custom-sec-title xb-sec-padding text-center">
              <span className="sub-title">Our Main Services</span>
              <h2 className="title">
                <span className="round-img">
                  <img src={gif} alt="gif" />
                </span>{" "}
                Full-stack web solutions for modern businesses
              </h2>
              <div className="xb-heading-btn d-inline">
                <Link className="thm-btn agency-btn" to="/service">
                  <span className="text">view more services</span>
                  <span className="arrow">
                    <span className="arrow-icon">
                      <ThmBtnArrow />
                      <ThmBtnArrow />
                    </span>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Service Boxes */}
      <div className="xb-service-wrap bg_img">
        {services.map((service) => (
          <div
            key={service.id}
            className={`xb-service-item xb-border xb-mouseenter ${activeId === service.id ? "active" : ""
              }`}
            onMouseEnter={() => setActiveId(service.id)}
          >
            <div className="xb-item--inner">
              <div className="xb-item--item">
                <div className="xb-item--head-item">
                  <h3 className="xb-item--title border-effect">
                    <Link to={service.link}>{service.title}</Link>
                  </h3>
                  <Link className="xb-item--icon" to={service.link}>
                    <img src={arrowIcon} alt="arrow" />
                  </Link>
                </div>
                <p className="xb-item--content">{service.desc}</p>
                <div className="xb-item--img">
                  <Link to={service.link}>
                    <img src={service.img} alt={service.title} loading="lazy" />
                  </Link>
                </div>
              </div>

              <div className="service-vertical-text">
                <h3 className="xb-item--title">
                  <Link to={service.link}>{service.title}</Link>
                </h3>
                <Link className="xb-icon" to="/service-details">
                  <svg
                    width="31"
                    height="31"
                    viewBox="0 0 31 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="6.28979"
                      y="21.4111"
                      width="22.36"
                      height="2.83936"
                      transform="rotate(-40.2798 6.28979 21.4111)"
                      fill="white"
                    />
                    <rect
                      x="9.44751"
                      y="7.57031"
                      width="2.83936"
                      height="2.83936"
                      transform="rotate(-40.2798 9.44751 7.57031)"
                      fill="white"
                    />
                    <rect
                      x="13.449"
                      y="7.90015"
                      width="2.83936"
                      height="2.83936"
                      transform="rotate(-40.2798 13.449 7.90015)"
                      fill="white"
                    />
                    <rect
                      x="17.4507"
                      y="8.23047"
                      width="2.83936"
                      height="2.83936"
                      transform="rotate(-40.2798 17.4507 8.23047)"
                      fill="white"
                    />
                    <rect
                      x="21.1223"
                      y="12.5627"
                      width="2.83936"
                      height="2.83936"
                      transform="rotate(-40.2798 21.1223 12.5627)"
                      fill="white"
                    />
                    <rect
                      x="20.7925"
                      y="16.5649"
                      width="2.83936"
                      height="2.83936"
                      transform="rotate(-40.2798 20.7925 16.5649)"
                      fill="white"
                    />
                    <rect
                      x="20.4617"
                      y="20.5667"
                      width="2.83936"
                      height="2.83936"
                      transform="rotate(-40.2798 20.4617 20.5667)"
                      fill="white"
                    />
                  </svg>
                </Link>

              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceSection;
